// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hqd73_ZOR9NmTJmA6keV {
    margin-bottom: 20px;
}

.q6sMrK2d0iwOv90JU227 {
    margin-bottom: 20px;
    border-bottom: 1px solid #aaa;
}

.HZHnEomObWN0HXlUncHJ {
    display: flex;
    justify-content: flex-start;
    position: fixed;
    bottom: 62px;
    width: calc(100% - 30px);
    max-width: 454px;
    background: white;
    padding: 10px 0;
    z-index: 3;
    left: 0;
    min-width: calc(100% - 30px);
    margin: 0 15px;
}

.QqTIynqhnCXtsscRokVP {
    display: flex;
    justify-content: space-between;
}

.HZHnEomObWN0HXlUncHJ a, .QqTIynqhnCXtsscRokVP a {
    display: block;
    flex: 1;
    width: 50%;
    max-width: 300px;
}

@media only screen and (min-width: 426px) {
    .HZHnEomObWN0HXlUncHJ {
        bottom: 44px;
    }
}
@media only screen and (min-width: 767px) {
    .HZHnEomObWN0HXlUncHJ {
        position: relative;
        z-index: auto;
        bottom: 0;
    }
} 
`, "",{"version":3,"sources":["webpack://./src/pages/eligibility/components/form/section.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,OAAO;IACP,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,OAAO;IACP,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,SAAS;IACb;AACJ","sourcesContent":[".sections {\n    margin-bottom: 20px;\n}\n\n.header {\n    margin-bottom: 20px;\n    border-bottom: 1px solid #aaa;\n}\n\n.navigation {\n    display: flex;\n    justify-content: flex-start;\n    position: fixed;\n    bottom: 62px;\n    width: calc(100% - 30px);\n    max-width: 454px;\n    background: white;\n    padding: 10px 0;\n    z-index: 3;\n    left: 0;\n    min-width: calc(100% - 30px);\n    margin: 0 15px;\n}\n\n.navigation-start {\n    display: flex;\n    justify-content: space-between;\n}\n\n.navigation a, .navigation-start a {\n    display: block;\n    flex: 1;\n    width: 50%;\n    max-width: 300px;\n}\n\n@media only screen and (min-width: 426px) {\n    .navigation {\n        bottom: 44px;\n    }\n}\n@media only screen and (min-width: 767px) {\n    .navigation {\n        position: relative;\n        z-index: auto;\n        bottom: 0;\n    }\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sections": `hqd73_ZOR9NmTJmA6keV`,
	"header": `q6sMrK2d0iwOv90JU227`,
	"navigation": `HZHnEomObWN0HXlUncHJ`,
	"navigation-start": `QqTIynqhnCXtsscRokVP`,
	"navigationStart": `QqTIynqhnCXtsscRokVP`
};
export default ___CSS_LOADER_EXPORT___;
